import { useMediaQuery, useTheme } from "@mui/material";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";
import { appUrl } from "Utils/UrlUtils";
import { useLocation } from "react-router";

const BASE_URL_PATHNAME = "/";

const ROLES_WITHOUT_IMAGE: Array<AccessRoleCode> = [
  AccessRoleCodes.Admin,
  AccessRoleCodes.Aml,
  AccessRoleCodes.CustomerOnboarding,
];

export const useHasBackgroundImage = () => {
  const { pathname } = useLocation();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const user = useLoggedInUser();

  const urlsWithImage = [
    BASE_URL_PATHNAME,
    appUrl("dashboard"),
    appUrl("initiate-keypad-payment"),
  ];

  const isHiddenForCurrentUserRole = user?.accessRoleCode
    ? ROLES_WITHOUT_IMAGE.includes(user.accessRoleCode as AccessRoleCode)
    : false;

  const isUserHeaderRoute = isMd && urlsWithImage.includes(pathname);

  return {
    hasBackgroundImage: isUserHeaderRoute && !isHiddenForCurrentUserRole,
    // Staff roles get a plain dashboard, but the mobile header (avatar with the context switcher,
    // notifications) still has to render there — on a phone it is the only way to switch context
    // or sign out.
    isUserHeaderRoute,
  };
};
